import api from "lib/api";

// export const getHolidayList = async (params = {}) => {
//   return await api.post("/v1/stpHolidayCalendar/getHoliday", params);
// };

// export const createHoliday = async (params = {}) => {
//   return await api.post("/v1/stpHolidayCalendar/createHoliday", params);
// };

// export const editHoliday = async (params = {}) => {
//   return await api.post("/v1/stpHolidayCalendar/updateHoliday", params);
// };

// export const deleteHoliday = async (params = {}) => {
//   return await api.post("/v1/stpHolidayCalendar/manageStatusHoliday", params);
// };

// * redesign
export const holidayGroupManagement = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/holidayCalendarGroupManagement", params);
};

export const getEmployeeInHolidayCalendarGroup = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/getEmployeeInHolidayCalendarGroup", params);
};

export const getHolidayCalendarGroupList = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/getHolidayCalendarGroupList", params);
};

export const holidayManagement = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/holidayCalendarManagement", params);
};

export const getHolidayCalendar = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/getHolidayCalendar", params);
};

export const getHolidayCalendarByGroup = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/getHolidayCalendarByGroup", params);
};

export const getHolidayPagingByCalendar = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/getHolidayPagingByCalendar", params);
};

export const manageStatusHolidayCalendar = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/manageStatusHolidayCalendar", params);
};

export const employeeHolidayCalendarManagement = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/employeeCalendarManagement", params);
};

export const getCalendarById = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/getCalendarById", params);
};

export const getEmployeeCalendarPaging = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/getEmployeeCalendarPaging", params);
};

export const duplicateCalendar = async (params = {}) => {
  return await api.post("/v1/holidayCalendar/duplicateCalendar", params);
};

export const getEmployeeByCompanyId = async (params = {}) => {
  return await api.post("/v1/dropdown/getEmployeeWithoutCalendar", params);
};





